import React from "react";
import { cls } from "@wss/cls";
import { ChatState } from "~/common/Store/models/RootReadonly";
interface Props {
  chat: ChatState;
}
const HoursText = ({
  children
}: {
  children: React.ReactNode;
}) => {
  return <span className={cls("flex", "justify-center", "text-2xs", "leading-none", "ml-0", "pb-1", "text-gray-700", "align-middle", "mt-[-1px]")} data-sentry-component="HoursText" data-sentry-source-file="Hours.tsx">
      {children}
    </span>;
};
const Hours = ({
  chat
}: Props) => {
  const lines = chat.hours?.lines?.map(s => s.split(": ")) ?? [];
  return <a href="/ask.html" title="WebstaurantStore Support" id="chat-message" className={cls("text-shadow-white-3", "block", "flex", "flex-col", "mt-3", "text-gray-800", "transition-opacity", "ease-in-out", "duration-100", "md:mt-0", "opacity-100", "md:px-4")} style={{
    height: 45,
    lineHeight: "44px"
  }} data-testid="chat-hours" data-sentry-component="Hours" data-sentry-source-file="Hours.tsx">
      {lines.map(line => {
      const [days, hours] = line;
      return <HoursText key={days}>
            <span className="whitespace-pre">{days ? `${days}: ` : ""}</span>
            <span>{hours ?? ""}</span>
          </HoursText>;
    })}
    </a>;
};
export default Hours;